import type { TutorialGuidanceDto } from '@onrunning/backstage-models';
import { defineStore } from 'pinia';

interface State {
  guidances: TutorialGuidanceDto[];
  fetched: boolean;
}

export const useTutorialGuidanceStore = defineStore('tutorial-guidance', {
  state: (): State => ({
    guidances: [],
    fetched: false,
  }),

  actions: {
    updateFetched(value: boolean) {
      this.fetched = value;
    },

    removeGuidance(guidanceIdx: number) {
      this.guidances.splice(guidanceIdx, 1);
    },

    updateGuidances(guidances: TutorialGuidanceDto[]) {
      this.guidances = guidances.filter((guidance) => guidance.isActive);
    },

    $reset() {
      this.guidances = [];
      this.fetched = false;
    },
  },
});
